import React from 'react';
import { Box, Typography } from '@mui/material';

interface AppLogoProps {
  compact?: boolean;
}

const AppLogo: React.FC<AppLogoProps> = ({ compact = false }) => {
  const fontSize = compact ? '1.1rem' : '1.3rem';

  return (
    <Box sx={{ userSelect: 'none' }}>
      <Typography
        variant={compact ? 'h6' : 'h5'}
        sx={{
          fontWeight: 700,
          letterSpacing: 0.5,
          color: '#ffffff',
          lineHeight: 1,
          fontSize
        }}
      >
        Fitness
      </Typography>
    </Box>
  );
};

export default AppLogo;
